import { normalize } from 'normalizr';
import * as schema from '../schema';

import * as actionTypes from './actionTypes';
import { axiosProtected } from '../../axios-wizard';


export const getInventoryObjects = (state, objectname, ids) => {
  if (state.inventory !== undefined && state.inventory[objectname] !== undefined && ids !== undefined) {
    const x = Object.values(state.inventory[objectname]).filter(x => ids.includes(x.id));
    return (Array.isArray(x))? x : undefined;
  } else {
    return [];
  }
}

export const getReduxObjects = (objects, ids) => {
  if (objects !== undefined && ids !== undefined && ids !== null ) {
    const x = Object.values(objects).filter(x => ids.includes(x.id));
    return (Array.isArray(x))? x : undefined;
  } else {
    return [];
  }
}


export const fetchProductsystemsStart = (  ) => {
    return {
        type: actionTypes.FETCH_PRODUCTSYSTEMS_START
    };
};

export const fetchProductsystemsSuccess = ( projects ) => {
    return {
        type: actionTypes.FETCH_PRODUCTSYSTEMS_SUCCESS,
        values: projects
    };
};

export const fetchProductsystemsFailed = () => {
    return {
        type: actionTypes.FETCH_PRODUCTSYSTEMS_FAILED
    };
};

export const fetchAllProductsystems = () => {
  const selectedSteps = {country: '', fwk: '', location: '', executionType: '', mediumTypes: ''};
  return fetchProductsystems(selectedSteps)
}

export const fetchProductsystems = (selectedSteps) => {
    const url = '/api/product_systems/' +
                          '?country=' +  selectedSteps.country +
                          '&fwk=' + selectedSteps.fwk +
                          '&installation_location=' + selectedSteps.location +
                          '&execution_type=' + selectedSteps.executionType +
                          '&medium_type=' + selectedSteps.mediumTypes


    return dispatch => {
        dispatch( fetchProductsystemsStart() );
        return axiosProtected.get( url )
            .then( response => {
               const normalized = normalize(response.data, { product_systems: schema.arrayOfProductSystems })
               dispatch(fetchProductsystemsSuccess(normalized));
               return normalized.result.product_systems
            } )
            .catch( error => {
                dispatch(fetchProductsystemsFailed());
            } );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/inventory.js